/*
 * Copyright (c) 2024-2026. The content provided herein is protected by copyright law. Unauthorized use, reproduction, or distribution of this material without proper licensing, knowledge, and contract agreement from the author is strictly prohibited. Any infringement of these rights may result in legal action. For inquiries regarding the use of this content, please contact the author for proper authorization and agreement.
 */
import React from 'react'
import { NavLink } from 'react-router-dom'
import clsx from 'clsx'
import { NavItem } from '../Sidebar'
import { useAppDispatch } from 'helpers/store'
import { closeModal, setHeadbarTitle } from 'helpers/actions'
import { setRemindersContext } from 'store/ui/UiReducer'

interface SidebarItemProps {
    item: NavItem
}

const SidebarItem: React.FC<SidebarItemProps> = ({ item }) => {
    const dispatch = useAppDispatch()

    return (
        <NavLink
            key={item.name}
            to={item.link}
            aria-label={item.name}
            title={item.name}
            onClick={() => {
                dispatch(closeModal())
                dispatch(setHeadbarTitle(null))
                dispatch(setRemindersContext(null))
            }}
            className={({ isActive }) =>
                clsx(
                    'SidebarItem flex flex-col items-center justify-center gap-0.5 px-0.5 lg:px-1 py-1.5 lg:py-2 text-[9px] lg:text-[10px] rounded-md font-medium transition-all duration-150 text-center',
                    isActive
                        ? 'isActive bg-gray-100 text-gray-900 dark:bg-gray-800 dark:text-gray-100'
                        : 'isNotaActive text-gray-700 hover:bg-gray-50 hover:text-gray-900 dark:text-gray-300 dark:hover:bg-gray-800 dark:hover:text-gray-100'
                )
            }
        >
            <item.icon className={clsx('w-4 h-4 lg:w-5 lg:h-5')} />
            <span className="block leading-tight">{item.name}</span>
        </NavLink>
    )
}

export default SidebarItem
